import React from 'react';
import { CsvUploadConfiguration } from '../types/csvUploadConfiguration';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { instanceToPlain } from 'class-transformer';

export interface CsvUploadConfigurationContextProps {
  csvUploadConfigurations: Map<string, CsvUploadConfiguration>;
  setCsvUploadConfigurations: (configurations: Map<string, CsvUploadConfiguration>) => void;
  csvUploadConfigurationsLoading: boolean;
}

const defaultContext: CsvUploadConfigurationContextProps = {
  csvUploadConfigurations: new Map(),
  setCsvUploadConfigurations: configurations => {},
  csvUploadConfigurationsLoading: false,
};

export const CsvUploadConfigurationContext = React.createContext<CsvUploadConfigurationContextProps>(defaultContext);

interface CsvUploadConfigurationState {
  items: Record<string, any>[];
  loading: boolean;
}

export const csvUploadConfigurationSlice = createSlice({
  name: 'csvUploadConfiguration',
  initialState: { items: [], loading: true } as CsvUploadConfigurationState,
  reducers: {
    reset: state => {
      state.items = [];
      state.loading = true;
    },
    setAll: (state, action: PayloadAction<CsvUploadConfiguration[]>) => {
      state.items = action.payload.map(p => instanceToPlain(p));
    },
    addAll: (state, action: PayloadAction<CsvUploadConfiguration[]>) => {
      const map = new Map([...state.items, ...action.payload.map(p => instanceToPlain(p))].map(pmd => [pmd.id, pmd]));
      state.items = [...map.values()];
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});
